module.exports = __webpack_public_path__ + "static/media/lap-steve.3d3652ee.jpg";